module.exports = __webpack_public_path__ + "img/astronaut.fff5aef3.png";